/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editdealform_Validation_Contributionexceedsdealsize6Inputs */

const en_coinvestments_editdealform_validation_contributionexceedsdealsize6 = /** @type {(inputs: Coinvestments_Editdealform_Validation_Contributionexceedsdealsize6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GP fund contribution cannot exceed the total deal size`)
};

/**
* | output |
* | --- |
* | "GP fund contribution cannot exceed the total deal size" |
*
* @param {Coinvestments_Editdealform_Validation_Contributionexceedsdealsize6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editdealform_validation_contributionexceedsdealsize6 = /** @type {((inputs?: Coinvestments_Editdealform_Validation_Contributionexceedsdealsize6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editdealform_Validation_Contributionexceedsdealsize6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editdealform_validation_contributionexceedsdealsize6(inputs)
});
export { coinvestments_editdealform_validation_contributionexceedsdealsize6 as "coInvestments_editDealForm_validation_contributionExceedsDealSize" }